<template>
  <div class="w-full">
    <div class="flex items-center justify-between w-full">
      <div class="flex">
        <img v-if="item.icon" class="w-20 h-20 mr-10" :src="require(`@/assets/images/icons/${item.icon}.png`)" alt="icon">
        <img v-else-if="item.icon === null" class="w-20 h-20 mr-10" src="@/assets/images/icons/purple_circle.png" alt="icon">
        <img v-else class="w-20 h-20 mr-10" src="@/assets/images/planet.svg" alt="icon">

        <div class="leading-tight">
          <div class="text-app-color truncate font-semibold">{{ item.title }}</div>
        </div>
      </div>

      <div
        class="rotate-icon opacity-0 group-hover:opacity-100 anim-opacity"
        :class="{'opacity-100': activeIndex}"
      >
        <i class="icon-arrow-up text-19 font-bold text-dark-600" />
      </div>
    </div>

    <p class="ml-30 text-14">{{ bookTitle }}</p>
    <!-- eslint-disable vue/no-v-html -->
    <div v-if="highlight.length > 0" class="highlight text-grey-250 ml-30">
      <span v-for="(h, index) in highlight" :key="h + index" v-html="h" />
    </div>
  </div>
</template>

<script>
import { getHighlightedItems } from '@/core/helper-functions'
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    item: Object,
    activeIndex: Boolean,
    query: String
  },

  setup (props) {
    const { state, getters } = useStore()

    const isTeamAccount = computed(() => getters.isTeamAccount)
    const headquarters = computed(() => state.team.headquarters)

    const books = computed(() => {
      const bks = state.book.books

      if (isTeamAccount.value) bks.push(headquarters.value)

      return bks
    })

    const bookTitle = computed(() => {
      const book = books.value.find(b => b.id === props.item.bookId)

      return book?.title || ''
    })

    const highlight = computed(() => {
      if (props.query && props.item.body && props.item.highlight.body) {
        return getHighlightedItems(props.item.body, props.query)
      }

      return []
    })

    return {
      // computed
      bookTitle,
      highlight
    }
  }
})
</script>
